import { render, staticRenderFns } from "./InsCatLayout2.vue?vue&type=template&id=4f3f58ea&scoped=true&"
import script from "./InsCatLayout2.vue?vue&type=script&lang=ts&"
export * from "./InsCatLayout2.vue?vue&type=script&lang=ts&"
import style0 from "./InsCatLayout2.vue?vue&type=style&index=0&id=4f3f58ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f58ea",
  null
  
)

export default component.exports